import React from 'react';

import { createSvgIcon } from '../../utils/createSvgIcon';

export const ZoomInIcon = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.5 9.5V7H10.5V9.5H13V10.5H10.5V13H9.5V10.5H7V9.5H9.5Z"
      fill="#FFFEF4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.3775 13.3775C11.461 15.2939 8.35381 15.2939 6.43735 13.3775C4.52089 11.461 4.52089 8.35381 6.43735 6.43735C8.35381 4.52089 11.461 4.52089 13.3775 6.43735C15.2939 8.35381 15.2939 11.461 13.3775 13.3775ZM13.7163 14.4233C11.3953 16.3854 7.91816 16.2725 5.73024 14.0846C3.42325 11.7776 3.42325 8.03723 5.73024 5.73024C8.03723 3.42325 11.7776 3.42325 14.0846 5.73024C16.2725 7.91814 16.3854 11.3952 14.4234 13.7162L19.8537 19.1465L19.1466 19.8536L13.7163 14.4233Z"
      fill="#FFFEF4"
    />
  </svg>,
  'ZoomInIcon'
);
